import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { MAX_WIDTH_SP } from "../../const";

export default class ModalTutorial extends Component {
  render() {
    let {
      isShowModalTutorial,
      handleUpdateState,
      getWidthBrowser
    } = this.props;

    return (
      <Modal
        show={isShowModalTutorial}
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="modal_tutorial modal_custom"
        onHide={() => handleUpdateState("isShowModalTutorial", false)}
        centered
      >
        <Modal.Body>
          <button
            className="modal_close"
            onClick={() => handleUpdateState("isShowModalTutorial", false)}
          >
            <img src="/img/icon_close_new.png" alt="" />
          </button>
          <img
            src={`${
              getWidthBrowser() < MAX_WIDTH_SP ? "/img/tutorial_sp.png" : "/img/tutorial.png"
            }`}
            alt="Pasral tool tutorial"
          />
        </Modal.Body>
      </Modal>
    );
  }
}
